import clsx from 'clsx';

interface Props {
  isVisible: boolean;
  onToggle: () => void;
  className?: {
    container?: string;
    switch?: string;
  };
  size?: 'sm' | 'md' | 'lg';
}

export default function ToggleSwitch({ isVisible, onToggle, className, size = 'md' }: Props) {
  const sizeMap: Record<Props['size'], string> = {
    sm: 'h-15px w-25px',
    md: 'h-20px w-30px',
    lg: 'h-30px w-50px',
  };

  return (
    <div
      className={clsx(
        'form-check form-switch form-check-custom form-check-solid',
        className?.container
      )}
    >
      <input
        className={clsx('form-check-input', sizeMap[size], className?.switch)}
        type='checkbox'
        value=''
        checked={isVisible}
        onChange={(e) => {
          e.stopPropagation();
          onToggle();
        }}
      />
    </div>
  );
}
